import React from 'react';
import { Field } from 'redux-form';
import { FormGroupRow, InfoLabel } from '../../../../common/components';
import CheckboxGroup from '../../../../common/components/ReduxFormField/CheckboxGroup';

const parseCalculationClass = (value) => {
  if (value) {
    return 'JustTravel\\Domain\\Services\\LeisureTravelCalculationService';
  }
  return null;
};
const formatCalculationClass = (value) => {
  return !!value;
};

export const CalculationClassField = ({ name, isViewOnly, label }) => (
  <FormGroupRow label={label} labelSize={4} fieldSize={6}>
    <Field
      name={name}
      parse={parseCalculationClass}
      format={formatCalculationClass}
      options={[{ label: '', value: true }]}
      component={isViewOnly ? InfoLabel : CheckboxGroup}
    />
  </FormGroupRow>
);
